import React from 'react'
import { observer } from 'mobx-react'
import { Row, Col, Dropdown, FormControl } from 'react-bootstrap'

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    className="d-flex custom-toggle align-items-center justify-content-between border rounded p-2"
    onClick={e => {
      e.preventDefault()
      onClick(e)
    }}>
    {children}
    &#x25bc;
  </div>
))

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = React.useState('')

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}>
        <FormControl
          autoFocus
          className="mx-1 my-2 w-auto"
          placeholder="Search..."
          onChange={e => setValue(e.target.value)}
          value={value}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            child =>
              !value ||
              child.props.children.toLowerCase().indexOf(value.toLowerCase()) >
                -1
          )}
        </ul>
      </div>
    )
  }
)

@observer
class OtherUsersList extends React.Component {
  constructor(props) {
    super(props)
    this.ulRef = React.createRef()
    this.inputRef = React.createRef()
    this.optionRef = React.createRef()
  }

  render() {
    const { defaultUser } = this.props
    const value =
      defaultUser && defaultUser.buyerInfo
        ? `${defaultUser.buyerInfo.firstName} ${defaultUser.buyerInfo.lastName}`
        : ''
    return (
      <Row noGutters className="m-0 pt-2 pb-2 other-users user-select">
        <Col lg={12}>
          <label className="pl-1 order-search-form-label w-100 m-0 text-truncate">
            Users
          </label>
          <Dropdown>
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <div id="search-bar" className="w-100">
                {value}
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu as={CustomMenu} ref={this.optionRef}>
              {this.props.options.map((option, index) => {
                const displayOption = `${option.buyerInfo.firstName} ${option.buyerInfo.lastName}`
                return (
                  <Dropdown.Item
                    eventKey={++index}
                    onClick={e => {
                      console.log(false)
                      this.props.handleUserChange(option)
                    }}
                    onSelect={() => {
                      console.log(true)
                    }}
                    active={value === displayOption}>
                    {displayOption}
                  </Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    )
  }
}

export default OtherUsersList
export { OtherUsersList }
